export default [
  { value: 'CASH', label: 'CASH' },
  { value: 'FHA', label: 'FHA' },
  { value: 'CONV', label: 'CONV' },
  { value: 'VA LOAN', label: 'VA LOAN' },
  { value: 'ANY', label: 'ANY' },
];
